<app-admin-table-toolbar
  [titleKey]="titleKey"
  [descriptionKey]="descriptionKey"
  [showSearch]="showSearch"
  [searchPlaceholderKey]="searchPlaceholderKey"
  [searchValue]="searchValue"
  (searchValueChange)="onSearchChange($event)"
>
  <ng-content select="[toolbar-actions]"></ng-content>
</app-admin-table-toolbar>
